import TypesenseError from './TypesenseError'

export default class ObjectUnprocessable extends TypesenseError {}
